import '../css/tailwind.css';
import '../css/base.css';

/**
 * vendor modules
 */
import 'lazysizes';

/**
 * Import vanilla JS helpers
 */
import ageGate from './components/age-gate-validator';
import toggleElems from './helpers/toggle-elems';
import playPauseVideosInView from './helpers/video-plays-in-view';
import addInViewClass from './helpers/in-view';
import addPageClassToBody from './helpers/add-page-class';
import redirectIftrusted from './helpers/bypass-age-gate';
import addScrolledClassToBody from './helpers/add-scolled-class-to-body';
import validateForm from './helpers/validate-form';
/**
 * Import vanilla JS components
*/
import awardsSwiper from './components/awards-swiper';
import faqAccordion from './components/faq-accordion';
import dynamicMedia from './components/dynamic-media';
import handleAjaxFormSubmit from './components/ajax-form-submit';
import stickyBuyButton from './components/sticky-buy-button';
// import initFakeDropdowns from './components/dropdown';
import subscribeForm from './components/subscribe-from';
import swirlingLiquid from './components/swirling-liquid';
import initArtcileSwiper from './components/media-swipers';
import interactWithMediaSwiper from './components/media-swiper';
import initCustomVideoSkin from './components/video-skin';

function hardPageLoad() {
  initCustomVideoSkin()
  ageGate()
  addPageClassToBody()
  addScrolledClassToBody()
  redirectIftrusted()
  swirlingLiquid()
  addInViewClass()
  playPauseVideosInView()
  awardsSwiper()
  initArtcileSwiper()
  faqAccordion()
  dynamicMedia()
  handleAjaxFormSubmit()
  stickyBuyButton()
  subscribeForm()
  interactWithMediaSwiper()
  validateForm('webform-submission-join-our-community-node-42-add-form');
  validateForm('webform-submission-contact-us-node-41-add-form');
  const { toggleNav, openCloseNav, toggleBag, playPauseAudio } = toggleElems();
  window.toggleBag = toggleBag;
  window.toggleNav = toggleNav;
  window.openCloseNav = openCloseNav;
  window.playPauseAudio = playPauseAudio;
}

//call it on hard page load
hardPageLoad();
